/**
 * Creates initial form data by mapping initial values to form fields with fallback defaults
 * @param initialData The initial data object (can be null/undefined)
 * @param fieldMapping Object mapping form field names to their default values
 * @returns Form data object with all fields set to initial values or defaults
 */
export function createInitialFormData<T, K extends Record<string, unknown>>(
  initialData: T | null | undefined,
  fieldMapping: K,
): K {
  const result = {} as K;

  for (const [fieldName, defaultValue] of Object.entries(fieldMapping)) {
    result[fieldName as keyof K] = (initialData?.[fieldName as keyof T] ??
      defaultValue) as K[keyof K];
  }

  return result;
}
